<template>
  <div class="more-login-entry">
    <a class="link" href="javascript:;" @click="openScanCodeLogin">{{
      letter.v3ScanCodeLogin
    }}</a>
    <span class="line">|</span>
    <a class="link" href="javascript:;" @click="openAccountLogin">{{
      letter.v3BindRole
    }}</a>
    <AccountLoginPopup
      v-bind:visible.sync="visibleAccountLoginPopup"
    ></AccountLoginPopup>
    <QrcodeLoginPopup
      v-bind:visible.sync="visibleQrCodeLoginPopup"
    ></QrcodeLoginPopup>
  </div>
</template>

<script>
import AccountLoginPopup from '@components/officialTopup/login/AccountLoginPopup.vue';
import QrcodeLoginPopup from '@components/officialTopup/login/QrcodeLoginPopup.vue';
export default {
  name: 'MoreLoginEntry',
  components: {
    AccountLoginPopup,
    QrcodeLoginPopup
  },
  data() {
    return {
      visibleAccountLoginPopup: false,
      visibleQrCodeLoginPopup: false
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    openScanCodeLogin() {
      this.visibleQrCodeLoginPopup = true;
    },
    openAccountLogin() {
      this.visibleAccountLoginPopup = true;
    }
  }
};
</script>

<style scoped lang="scss">
.more-login-entry {
  display: flex;
  justify-content: flex-end;
  color: #333;
  font-size: 20px;
  padding: 0 40px;
  .link {
    color: #333;
    cursor: pointer;
  }
  .line {
    margin: 0 20px;
  }
}
</style>
